import { differenceInDays, differenceInMonths, startOfYear } from 'date-fns';

/**
 * Determines intelligent segmentation based on date range duration for year-to-date periods
 * 
 * Rules:
 * - If YTD period is 1 month or less: segment by 'date'
 * - If YTD period is more than 1 month but less than 3 months: segment by 'week'  
 * - Any other YTD scenario: segment by 'month'
 */
export function getYTODSegmentation(datePeriod: string): 'date' | 'week' | 'month' {
    const today = new Date();
    const yearStart = startOfYear(today);
    const monthsDiff = differenceInMonths(today, yearStart);

    if (monthsDiff <= 1) {
        return 'week';
    }

    return 'month';
}

export function getDatesSegmentation(from: Date, to: Date): 'date' | 'week' | 'month' {
    const daysDiff = differenceInDays(to, from);
    const monthsDiff = differenceInMonths(to, from);

    if (daysDiff <= 14) {
        return 'date';
    }

    if (monthsDiff <= 2) {
        return 'week';
    }

    return 'month';
}
